import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TrevorIcon } from '@trevor/ui-components';
import { userAction } from '@/util/helpers/ajax-helpers';
import { TrevorLink } from '@/components/TrevorLink';
import flex from '../css/module/flex.css';
import css from '../css/module/upgradeNow.css';
import { BILLING } from '../util/enums/views.constants';

export const UpgradeNow = () => {
  React.useEffect(() => {
    userAction('visit-trial-has-ended-page');
  }, []);

  return (
    <div className={css.container}>
      <div
        style={{ marginTop: '-25px' }}
        className={`${flex.column} ${flex.alignItemsCenter}`}
      >
        <TrevorIcon
          name="logo-wordmark"
          height="24"
          width="139.87"
          style={{ marginBottom: '85px' }}
        />
        <div className={`${css.message} box-shadow`}>
          <h4>You've exceeded the limits of the free plan</h4>
          <div className={`${css.creditLink}`}>
            <a href="https://trevor.io/pricing/" target="_blank">
              Learn more on credits
            </a>
          </div>
          <TrevorLink
            to="billing"
            className={`${css.billingBox} user-clickable ${flex.alignItemsCenter}`}
          >
            <div className={flex.grow}>
              <div className={flex.column}>
                <p className={css.title}>Upgrade your subscription</p>
                <p>To continue using Trevor.io, you need to pick a plan.</p>
              </div>
            </div>
            <div className="margin-left-30">
              <FontAwesomeIcon icon="chevron-right" />
            </div>
          </TrevorLink>
        </div>
        <div className="margin-top-30">
          <FontAwesomeIcon icon="info-circle" />
          <span style={{ marginLeft: '8px' }}>
            Need help or more time?&nbsp;
            <span className="link" onClick={() => Intercom('show')}>
              Chat with us
            </span>
            .
          </span>
        </div>
      </div>
    </div>
  );
};
class _UpgradeNow extends Component {
  componentDidMount() {
    userAction('visit-trial-has-ended-page');
  }

  loadBilling() {
    userAction('click-choose-paid-plan');
    this.props.onChangeTab(BILLING)();
  }

  render() {
    return (
      <div className={css.container}>
        <div
          style={{ marginTop: '-25px' }}
          className={`${flex.column} ${flex.alignItemsCenter}`}
        >
          <TrevorIcon
            name="logo-wordmark"
            height="24"
            width="139.87"
            style={{ marginBottom: '85px' }}
          />
          <div className={`${css.message} box-shadow`}>
            <h4>You've exceeded the limits of the free plan</h4>
            <div className={`${css.creditLink}`}>
              <a href="https://trevor.io/pricing/" target="_blank">
                Learn more on credits
              </a>
            </div>
            <div
              onClick={() => this.loadBilling()}
              className={`${css.billingBox} user-clickable ${flex.alignItemsCenter}`}
            >
              <div className={flex.grow}>
                <div className={flex.column}>
                  <p className={css.title}>Upgrade your subscription</p>
                  <p>To continue using Trevor.io, you need to pick a plan.</p>
                </div>
              </div>
              <div className="margin-left-30">
                <FontAwesomeIcon icon="chevron-right" />
              </div>
            </div>
          </div>
          <div className="margin-top-30">
            <FontAwesomeIcon icon="info-circle" />
            <span style={{ marginLeft: '8px' }}>
              Need help or more time?&nbsp;
              <span className="link" onClick={() => Intercom('show')}>
                Chat with us
              </span>
              .
            </span>
          </div>
        </div>
      </div>
    );
  }
}
